export default "__VITE_ASSET__DinfIV3i__"